export const getLoadingStatusLabel = (t, status) => {
    switch (status) {
        case 'running':
            return t('Running...');
        case 'prettifying':
            return t('Formatting results...');
        case 'thinking':
        default:
            return t('Thinking...');
    }
};
